// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';

import { TextField } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

type Props = {
  rootStyle?: {},
};

export function FieldIndiaState({ rootStyle }: Props): Node {
  const inputId = useUniqueId();
  const [value, handleChange] = useUserInputAsTextField('indiaState');
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('indiaState');
  const submitting = useSubmitting();

  const isOptionalFieldByPaymentType = useCurrentPaymentTypeOptionalFields('state');

  if (isOptionalFieldByPaymentType) {
    return null;
  }

  return (
    <div style={rootStyle} data-test-name="address-state">
      <label htmlFor={inputId}>State acronym *</label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        readOnly={submitting}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="address-state"
      />

      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </div>
  );
}

type ValidationMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return (
        <ErrorLabel>
          State is mandatory
        </ErrorLabel>
      );

    case 'server-error':
      return (
        <ErrorLabel>
          {serverErrorMessage(validationError.payload)}
        </ErrorLabel>
      );

    default:
      return (
        <ErrorLabel>
          Invalid state
        </ErrorLabel>
      );
  }
}
